var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      class: _vm.className,
      attrs: { disabled: _vm.disabled },
      on: { click: _vm.handleClick }
    },
    [
      _vm.state === "loading"
        ? _c("ep-spinner", { staticClass: "icon" })
        : _vm.state === "success"
        ? _c("tick-icon", { staticClass: "icon" })
        : _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }